import React from 'react';
import './PageTitle.css';

const PageTitle = ({ text, alignText = 'left', privacyMaskTitle, modernLayout }) => {
  const className = `pageTitle ${alignText || ''}`;
  return (
    <div
      className={`pageTitleContainer ${modernLayout && 'modernLayout'}`}
      data-dd-privacy={privacyMaskTitle ? 'mask' : ''}
    >
      <h1 className={className}>{text}</h1>
    </div>
  );
};

export default PageTitle;
